var _circle, _circle2, _path, _path2, _path3, _polygon, _rect, _path4, _polygon2, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketPart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 118.7 133",
    enableBackground: "new 0 0 118.7 133",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    cx: 53.5,
    cy: 83,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    cx: 41.8,
    cy: 84.5,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005D9A",
    d: "M59.8,50.6c-3.5,0-6.3,2.8-6.3,6.2s2.8,6.3,6.3,6.3c3.4,0,6.3-2.8,6.3-6.3C66.1,53.4,63.3,50.6,59.8,50.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005D9A",
    d: "M70.9,94.2h4.9v-4.8h9.6v-12l-9.6-5V59c0-7.5-8.2-18.8-15.9-18.8S44,51.5,44,59v13.4l-9.6,5v12H44v4.8h4.9 V99H71C70.9,99,70.9,94.2,70.9,94.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8F2F9",
    enableBackground: "new    ",
    d: "M72.8,91.4h-26V59c0-5.9,6.8-16,13-16s13,10,13,16C72.8,59,72.8,91.4,72.8,91.4 z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8F2F9",
    enableBackground: "new    ",
    points: "75.8,75.6 82.5,79.1 82.5,86.4 75.8,86.4 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.6,
    y: 94.2,
    fill: "#E8F2F9",
    enableBackground: "new    ",
    width: 16.4,
    height: 1.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#005D9A",
    d: "M61.3,71.5c0-1.8-3-1.8-3,0v16c0,1.8,3,1.8,3,0V71.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8F2F9",
    enableBackground: "new    ",
    points: "37.1,79.2 43.8,75.7 43.8,86.5 37.1,86.5 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M59.8,51.9c2.6,0,5,2.2,5,5c0,2.6-2.3,4.8-5,4.8 c-2.6,0-5-2.2-5-4.8C54.8,54.1,57.2,51.9,59.8,51.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#005D9A",
    d: "M82.1,94.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    d: "M60.4,100.7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 80,
    y1: 94.2,
    x2: 80,
    y2: 112.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "110.2; 114.7; 110.2;",
    begin: "0s",
    dur: "0.08s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 39,
    y1: 94.2,
    x2: 39,
    y2: 114.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "110.2; 114.7; 110.2;",
    begin: "0s",
    dur: "0.13s",
    repeatCount: "indefinite"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 52.7,
    y1: 104.4,
    x2: 52.7,
    y2: 116.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "112.6; 116.6; 112.6;",
    begin: "0s",
    dur: "0.11s",
    repeatCount: "indefinite"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 66.8,
    y1: 104.4,
    x2: 66.8,
    y2: 112
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "104.4; 112; 104.4;",
    begin: "0s",
    dur: "0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "110; 112; 110;",
    begin: "0s",
    dur: "0.10s",
    repeatCount: "indefinite"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 59.8,
    y1: 104.4,
    x2: 59.8,
    y2: 120
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "115.5; 120; 115.5;",
    begin: "0s",
    dur: "0.09s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketPart);
export default __webpack_public_path__ + "static/media/rocketPart.fb48e25d.svg";
export { ForwardRef as ReactComponent };